import React from 'react';
import { useLeads } from '../context/LeadContext';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { Link } from 'react-router-dom';

const { FiUsers, FiDownload, FiArrowLeft } = FiIcons;

const Admin = () => {
  const { leads } = useLeads();

  const handleExport = () => {
    // Simple CSV export logic
    const headers = ['Date', 'Name', 'Business', 'Email', 'Phone', 'Locations', 'Website'];
    const csvContent = [
      headers.join(','),
      ...leads.map(l => `${l.date},"${l.name}","${l.business}",${l.email},${l.phone},${l.locations},${l.website || ''}`)
    ].join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'trial_leads.csv';
    link.click();
  };

  return (
    <div className="p-8 max-w-7xl mx-auto">
      <div className="mb-8 flex items-center justify-between">
        <div>
          <Link to="/" className="text-slate-500 hover:text-primary flex items-center gap-2 mb-4 text-sm font-medium">
            <SafeIcon icon={FiArrowLeft} /> Back to Website
          </Link>
          <h1 className="text-3xl font-bold text-primary">Lead Management</h1>
          <p className="text-slate-600 mt-1">Track and manage your free trial signups.</p>
        </div>
        <button 
          onClick={handleExport}
          className="flex items-center gap-2 bg-white border border-slate-200 text-slate-700 px-4 py-2 rounded-lg font-medium hover:bg-slate-50 shadow-sm"
        >
          <SafeIcon icon={FiDownload} /> Export CSV
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-100 flex items-center gap-4">
          <div className="w-12 h-12 bg-blue-100 text-blue-600 rounded-lg flex items-center justify-center">
            <SafeIcon icon={FiUsers} className="w-6 h-6" />
          </div>
          <div>
            <p className="text-sm text-slate-500 font-medium">Total Trial Signups</p>
            <p className="text-2xl font-bold text-primary">{leads.length}</p>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-slate-100 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="bg-slate-50 border-b border-slate-100 text-slate-500 text-sm uppercase tracking-wider">
                <th className="p-4 font-medium">Date</th>
                <th className="p-4 font-medium">Contact</th>
                <th className="p-4 font-medium">Business</th>
                <th className="p-4 font-medium">Locations</th>
                <th className="p-4 font-medium">Status</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {leads.map((lead) => (
                <tr key={lead.id} className="hover:bg-slate-50 transition-colors">
                  <td className="p-4 text-sm text-slate-600 whitespace-nowrap">{lead.date}</td>
                  <td className="p-4">
                    <div className="font-medium text-primary">{lead.name}</div>
                    <div className="text-sm text-slate-500">{lead.email}</div>
                    <div className="text-sm text-slate-500">{lead.phone}</div>
                  </td>
                  <td className="p-4">
                    <div className="font-medium text-slate-700">{lead.business}</div>
                    {lead.website && <a href={lead.website} target="_blank" rel="noreferrer" className="text-sm text-secondary hover:underline">{lead.website}</a>}
                  </td>
                  <td className="p-4 text-sm text-slate-600">{lead.locations}</td>
                  <td className="p-4">
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                      Active Trial
                    </span>
                  </td>
                </tr>
              ))}
              {leads.length === 0 && (
                <tr>
                  <td colSpan="5" className="p-8 text-center text-slate-500">No leads found yet.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Admin;